export const heroData = {
	chipText: 'Rbi registered nbfc',
	titleLines: ['Unlock&nbsp; liquidity from', 'your investments'],
	description:
		'AngelOne Fincap Private Limited provides transparent credit solutions that allow you to borrow against your financial investments without selling them.',
	buttonText: 'Explore Products',
	buttonLink: '/terms-and-conditions',
	images: {
		desktop: 'images/hero-people.webp',
		mobile: 'images/hero-people.webp',
		alt: 'Hero people'
	}
};

export const featuresData = {
	title: 'Where Trust Meets Technology',
	description:
		'With a focus on transparency, security, and digital innovation, we ensure a smooth and trustworthy borrowing experience at every step.',
	items: [
		{
			image: 'images/transparency.svg',
			altText: 'Transparent icon',
			title: 'Transparent',
			subtitle: 'Clear Policies',
			titleClass: 'section_large text-backdrop',
			imageContainerClass: 'relative h-[3.75rem] w-[3.75rem] rounded-full bg-transparent',
			imageClass: 'absolute inset-0 h-full w-full rounded-full'
		},
		{
			image: 'images/secure.svg',
			altText: 'Secure icon',
			title: 'Secure',
			subtitle: 'Regulated Lending',
			titleClass: 'section_small text-backdrop lg:section_large',
			imageContainerClass: 'relative h-[3.75rem] w-[3.75rem] rounded-full bg-transparent',
			imageClass: 'absolute inset-0 h-full w-full rounded-full'
		},
		{
			image: 'images/digital.svg',
			altText: 'Digital icon',
			title: 'Digital',
			subtitle: 'Modern Processes',
			titleClass: 'section_large text-backdrop',
			imageContainerClass: 'relative h-[4rem] w-[3.75rem]',
			imageClass: 'absolute inset-0 h-full w-full'
		}
	]
};

export const contactData = {
	title: 'Contact Us',
	methods: [
		{
			id: 'email',
			icon: 'images/icon-email.svg',
			text: 'Email support@angelone.in'
		},
		{
			id: 'phone',
			icon: 'images/icon-phone.svg',
			text: 'Call (+91 9866655232)'
		}
	]
};

export const faqItems = [
	{
		title: 'What is Loan Against Securities?',
		body: 'You can borrow against securities without selling them.'
	},
	{
		title: 'Which securities are available?',
		body: 'Listed shares and ETFs are available as collateral for borrowing.'
	},
	{
		title: 'Can I apply through the website?',
		body: 'Yes, you can apply through the website by following the simple application process.'
	},
	{
		title: 'How do I get started?',
		body: 'Sign up on our platform and follow the guided steps to get started with your loan application.'
	}
];

export const productsData = {
	title: 'Our Products',
	items: [
		{
			title: 'Loan Against Securities',
			description: "Borrow against listed shares or ETF's while continuing to stay invested.",
			image: 'images/las.svg',
			altText: 'Loan Against Securities illustration',
			accentClass:
				'top-4 bottom-3 left-0 w-full bg-[#f93] lg:-left-8 lg:-bottom-8 lg:-right-8 lg:top-8',
			accentStyle: ''
		},
		{
			title: 'Loan Against Mutual Funds',
			description: 'Coming Soon...',
			image: 'images/lamf.svg',
			altText: 'Loans Against Mutual Funds illustration',
			accentClass: 'left-4 right-0 top-2 -bottom-2 lg:-right-8 lg:-bottom-8 lg:left-8 lg:top-8',
			accentStyle: 'background-color: var(--G-5);'
		}
	]
};

export const lspPartnersData = {
	title: 'LSP Partners',
	logos: [
		{
			src: 'images/ao_logo.svg',
			altText: 'AngelOne Partner Logo'
		}
	]
};
